module.exports = __webpack_public_path__ + "static/media/physio.d2232d67.svg";